import Header from "@/components/marketing/Header";
import Footer from "@/components/marketing/Footer";
import SEO from "@/components/marketing/SEO";
import FeaturesDetailed from "@/components/marketing/FeaturesDetailed";
import Guarantees from "@/components/marketing/Guarantees";
import BillingNote from "@/components/marketing/BillingNote";
import HospitalityApplicationForm from "@/components/marketing/HospitalityApplicationForm";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { GraduationCap, Check, Sparkles } from "lucide-react";

const conditions = [
  "Diplômé d'une école hôtelière suisse depuis moins de 3 ans",
  "Restaurant ouvert depuis moins de 18 mois",
  "Justificatif demandé : diplôme + extrait du registre du commerce",
  "20 places attribuées par année civile",
];

const OffreEcoleHoteliere = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Offre École Hôtelière · Piktable · 29 CHF à vie"
        description="Offre Piktable pour les diplômés d'école hôtelière suisse qui lancent leur restaurant. 29 CHF par mois à vie, 60 jours gratuits, 20 places par an."
        canonical="/offre/ecole-hoteliere"
      />
      <Header />
      <main className="pt-16">
        <section className="relative py-20 md:py-28 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary to-accent opacity-95" />
          <div className="container mx-auto px-4 relative z-10 text-center">
            <div className="inline-flex items-center gap-2 bg-white/15 border border-white/30 rounded-full px-4 py-1.5 mb-6">
              <GraduationCap className="w-4 h-4 text-white" />
              <span className="text-xs uppercase tracking-widest text-white font-semibold">
                Offre École Hôtelière · 20 places par an
              </span>
            </div>
            <h1 className="font-playfair text-4xl md:text-6xl font-bold text-white mb-6 max-w-3xl mx-auto leading-tight">
              Ton premier outil<br />de réservation.
            </h1>
            <p className="text-xl text-white/90 max-w-2xl mx-auto leading-relaxed">
              Une offre pensée pour les diplômés d'école hôtelière suisse qui lancent leur propre restaurant. Tarif bloqué à vie, 60 jours d'essai.
            </p>
          </div>
        </section>

        <section className="py-16 bg-background">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
              <Card className="border-2 border-primary bg-card shadow-lg">
                <CardContent className="p-8 space-y-6 relative">
                  <Badge className="absolute -top-3 left-6 bg-primary text-primary-foreground">
                    <Sparkles className="w-3 h-3 mr-1" />
                    20 places par an
                  </Badge>
                  <div>
                    <p className="text-xs uppercase tracking-widest text-primary font-semibold mb-2">
                      Tarif École Hôtelière
                    </p>
                    <p className="text-sm text-muted-foreground">
                      60 jours gratuits, bloqué à vie
                    </p>
                  </div>
                  <div className="flex items-baseline gap-2">
                    <span className="font-playfair text-6xl font-bold text-primary">29</span>
                    <span className="text-muted-foreground text-lg">CHF / mois · à vie</span>
                  </div>
                  <p className="text-base text-foreground leading-relaxed">
                    Tarif bloqué à vie, tant que ton abonnement reste actif. Destiné aux jeunes restaurateurs qui se lancent après leur formation.
                  </p>
                </CardContent>
              </Card>

              <Card className="border-border bg-card">
                <CardContent className="p-8 space-y-4">
                  <h2 className="font-playfair text-2xl font-semibold text-foreground">
                    Conditions d'accès
                  </h2>
                  <ul className="space-y-3">
                    {conditions.map((c) => (
                      <li key={c} className="flex items-start gap-3">
                        <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <Check className="w-4 h-4 text-primary" />
                        </div>
                        <span className="text-foreground leading-relaxed">{c}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>

        <FeaturesDetailed
          heading="Tout ce dont tu as besoin pour démarrer"
          subheading="Toutes les fonctionnalités incluses, dès le premier jour."
        />

        <BillingNote />

        <section className="py-20 bg-muted/30">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="font-playfair text-4xl md:text-5xl font-bold text-foreground mb-4">
                  Candidate à l'offre
                </h2>
                <p className="text-lg text-muted-foreground">
                  Remplis ce formulaire. Nous revenons vers toi sous 3 jours ouvrés avec les prochaines étapes.
                </p>
              </div>
              <HospitalityApplicationForm />
            </div>
          </div>
        </section>

        <Guarantees compact />
      </main>
      <Footer />
    </div>
  );
};

export default OffreEcoleHoteliere;
